module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-5.jpg?v=6fd09002";